import { applyMiddleware, combineReducers, createStore } from 'redux';
import { default as thunkMiddleware } from 'redux-thunk';

import objectErrorFormReducer, {
  IObjectErrorFormState,
} from '../bundles/business_shopping_center_detail/components/object_error_form/reducers/object_error_form_reducer';
import formReducer, { IFormState } from '../bundles/form/reducers/form';
import popupReducer, { IPopupState } from '../bundles/popup/reducers/popup';

export interface IApplicationState {
  form: IFormState;
  objectErrorForm: IObjectErrorFormState;
  popup: IPopupState;
}

const middlewares = [thunkMiddleware];

if (process.env.NODE_ENV !== 'production') {
  const createLogger = require('redux-logger');

  middlewares.push(createLogger());
}

let finalCreateStore = createStore;

finalCreateStore = applyMiddleware(
  ...middlewares
)(finalCreateStore);

const store = finalCreateStore<IApplicationState>(combineReducers<IApplicationState>({
  form: formReducer,
  objectErrorForm: objectErrorFormReducer,
  popup: popupReducer,
}));

export default store;



// WEBPACK FOOTER //
// ./src/di/store-bsc-detail.ts